import { useEffect } from 'react';
import { connect } from 'react-redux';
import { settingsActions } from '../../reducers/settings.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import ConstantsTemplate from './constants/ConstantsTemplate.react';
import ConstantsMetaData from './constants/ConstantsMetaData.react';
import AccessRestricted from '../app/routing/AccessRestricted.react';
var Constants = function Constants(_ref) {
  var constants = _ref.constants,
    getConstantsAction = _ref.getConstantsAction;
  useEffect(function () {
    getConstantsAction();
  }, []);
  if (!useHasPermission('view-constants')) return /*#__PURE__*/React.createElement(AccessRestricted, null);

  // TODO :: split to pages and make tables per app
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Applications",
    slug: "applications",
    disableSelectApp: true,
    disableAdd: true,
    hideApp: true,
    constants: constants.applications || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "User Roles",
    slug: "user-roles",
    hideApp: true,
    disableSelectApp: true,
    constants: constants.userRoles || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Environments",
    slug: "environments",
    constants: constants.environments || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Feature Flags",
    slug: "feature-flags",
    constants: constants.featureFlags || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Page Types",
    slug: "page-types",
    constants: constants.pageTypes || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Article Types",
    slug: "article-types",
    constants: constants.articleTypes || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Navigation Bars",
    slug: "nav-bars",
    constants: constants.navigationBars || []
  }), /*#__PURE__*/React.createElement(ConstantsMetaData, {
    title: "Meta Data",
    constants: constants.metaData || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Contact Types",
    slug: "contact-types",
    constants: constants.contactTypes || []
  }), /*#__PURE__*/React.createElement(ConstantsTemplate, {
    title: "Permission Groups",
    slug: "permission-groups",
    constants: constants.permissionGroups || []
  })));
};
var mstp = function mstp(s) {
  return {
    constants: s.settings.constants
  };
};
var mdtp = {
  getConstantsAction: settingsActions.getConstants
};
export default connect(mstp, mdtp)(Constants);